export const uk = {
    country: 'Страна',
    disclaimer: 'Предупреждение'
};
